import { render, staticRenderFns } from "./GuestTableNumberEntry.vue?vue&type=template&id=e34f58ba&scoped=true&"
import script from "./GuestTableNumberEntry.vue?vue&type=script&lang=js&"
export * from "./GuestTableNumberEntry.vue?vue&type=script&lang=js&"
import style0 from "./GuestTableNumberEntry.vue?vue&type=style&index=0&id=e34f58ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34f58ba",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm});
